// Get Limits
export const GET_LIMITS_REQUEST = "GET_LIMITS_REQUEST";
export const GET_LIMITS_SUCCESS = "GET_LIMITS_SUCCESS";
export const GET_LIMITS_FAILURE = "GET_LIMITS_FAILURE";

// Status Configuration Loader
export const STATUS_CONFIG_LOADER_START = "STATUS_CONFIG_LOADER_START";
export const STATUS_CONFIG_LOADER_STOP = "STATUS_CONFIG_LOADER_STOP";

// Reset State
export const RESET_STATUS_CONFIG_STATE = "RESET_STATUS_CONFIG_STATE";

// Update Limits
export const UPDATE_LIMITS_REQUEST = "UPDATE_LIMITS_REQUEST";
export const UPDATE_LIMITS_SUCCESS = "UPDATE_LIMITS_SUCCESS";
export const UPDATE_LIMITS_FAILURE = "UPDATE_LIMITS_FAILURE";
